function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C17.5229 2 22 6.47667 22 12C22 17.5233 17.5229 22 12 22C6.47711 22 2 17.5233 2 12C2 6.47667 6.47711 2 12 2ZM12 4C7.58151 4 4 7.5814 4 12C4 16.4186 7.58151 20 12 20C16.4185 20 20 16.4186 20 12C20 7.5814 16.4185 4 12 4ZM8.47173 13.743L8.43526 13.6321C8.25164 13.1663 7.74396 12.9018 7.24835 13.0336C6.71461 13.1755 6.39697 13.7232 6.53889 14.257C7.07574 16.276 9.44569 18 12.0248 18C14.5656 18 16.9331 16.2514 17.5141 14.2831C17.6705 13.7534 17.3679 13.1973 16.8382 13.0409C16.3085 12.8846 15.7523 13.1872 15.596 13.7169C15.2672 14.8305 13.6837 16 12.0248 16C10.3314 16 8.7698 14.864 8.47173 13.743ZM9.5 8C10.3284 8 11 8.67157 11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8ZM16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11C15.3284 11 16 10.3284 16 9.5Z"
});

var SvgISmile = function SvgISmile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgISmile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-smile.e71b5764.svg";
export { ForwardRef as ReactComponent };